<template>
    <div v-if="currentAccountSets" class="flex items-center">
        <Select ref="astRef"
            v-model="currentAccountSetsId"
            :datas="myAccountSets"
            :deletable="false"
            :equalWidth="false"
            className="as-select"
            filterable
            keyName="id"
            titleName="companyName" @change="changeAccountSets">
            <template #item="{item}">
                {{ item.companyName }}
                <vxe-button mode="text" icon="vxe-icon-copy" class="mr-20px" @click.stop="copyEvent(item.companyName)" style="padding: 0;"></vxe-button>
                <!--        <div class="text-gray-400 text-12px mt-5px">-->
                <!--          ({{ dictMapping(item.accountStandard, 'accountingStandards') }}-->
                <!--          - -->
                <!--          {{ dictMapping(item.vatType, 'vatRadios') }})-->
                <!--        </div>-->
            </template>
        </Select>
        <vxe-button mode="text" icon="vxe-icon-copy" class="mr-20px" @click="copyEvent(null)" style="padding: 0;"></vxe-button>
        <!--    <Tooltip content="账套管理">-->
        <!--      <div @click="editAs" class="fi fi-setting text-hover mr-34px !w-22px !h-22px"></div>-->
        <!--    </Tooltip>-->
    </div>
</template>
<script>
import {mapGetters, mapMutations, mapState} from 'vuex';
import {dictMapping, loading, message} from "heyui.ext";
import common from "@api/common";
import {VxeUI} from "vxe-pc-ui";

export default {
    name: 'AppHeaderAccountSets',
    data() {
        return {
            messageList: [],
            currentAccountSetsId: null,
            currentAccountSetsName:null,
        };
    },
    methods: {
        dictMapping,
        ...mapMutations(['newTab']),
        changeAccountSets(as) {
            if (as.id !== this.currentAccountSets.id) {
                loading("正在切换，请稍后...");
                common.changeAccountSets(as.id).then(() => {
                    message('切换成功！');
                    localStorage.removeItem(this.currentTabKey);
                    if(this.prod){
                        window.location.replace('https://financial.hxkjzg.com?isManage=2&accountSetId=' + as.id);
                    }else{
                        window.location.replace('http://localhost:9012?isManage=2&accountSetId=' + as.id);
                    }
                });
            }
        },
        copyEvent(name){
            if(name){
                VxeUI.clipboard.copy(name)
                this.$refs.astRef.dropdown.hide();
            }else{
                VxeUI.clipboard.copy(this.currentAccountSetsName)
            }
            VxeUI.modal.message({
                status: 'success',
                content: '复制成功',
                duration: 1000
            })
        },
        editAs() {
            this.newTab({
                key: 'Account',
                title: "账套"
            })
        }
    },
    computed: {
        ...mapState(['currentAccountSets', 'myAccountSets', 'prod']),
        ...mapGetters(['currentTabKey']),
    },
    watch: {
        'currentAccountSets.id'(id) {
            this.currentAccountSetsId = id;
        }
    },
    created() {
        if (this.currentAccountSets) {
            this.currentAccountSetsId = this.currentAccountSets.id;
            this.currentAccountSetsName = this.currentAccountSets.companyName;
        }
    }
};
</script>
<style lang='less'>
.app-header-message-vue {
    float: left;
    margin-right: 10px;

    .h-dropdowncustom-show {
        height: @layout-header-height;

        .app-header-icon-item {
            margin-right: 0;
        }

        &.h-pop-trigger {
            background: @hover-background-color;
        }
    }
}

.app-account-sets-dropdown-dropdown-container {
    width: 300px;
    min-height: 300px;

    .common-list-container {
        .common-list-item {
            cursor: pointer;
            padding: 10px;

            &:hover {
                background: @hover-background-color;
            }

            &.current {
                background: @primary-color;
                color: @white-color;
            }
        }
    }
}
</style>
